import React from 'react';

export default class Page11 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToMotivateOthers');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="desktop ipad-portrait-show">
                                                <table className="ilead_v_sport tablesrink para-bottompad"
                                                       border="0" cellPadding="0" cellSpacing="0" width="100%"
                                                       style={{marginBottom: '15px !important' }}>
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve" align="left" valign="top"
                                                            width="20%">Motivational area
                                                        </th>
                                                        <th align="left" valign="top" width="40%">High (4-5)
                                                        </th>
                                                        <th colSpan="4" className=" green_curve1" align="left"
                                                            valign="top" width="40%">Low (1-2)
                                                        </th>

                                                    </tr>


                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%">
                                                            <div className="paddingcenter10"><span
                                                                className="subtitle-table"><strong>Control</strong></span>
                                                            </div>
                                                        </td>

                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="40%">
                                                            <ul className="greenbullet-list">
                                                                <li>Likes to take control of team activities
                                                                </li>
                                                                <li> Does things in own way, regardless of
                                                                    feedback
                                                                </li>
                                                                <li>Does not like uncertain situations</li>
                                                                <li className="list-bottom-pad"> May find it
                                                                    difficult to delegate to others
                                                                </li>

                                                            </ul>
                                                            <p>Provide them with however much responsibility or
                                                                ownership you’re happy to! Clarify the
                                                                boundaries between their role and those of
                                                                others.</p>

                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="40%">
                                                            <ul className="greenbullet-list">
                                                                <li> Will allow others to lead</li>
                                                                <li>Best employed in a supporting role where
                                                                    others take charge
                                                                </li>
                                                                <li> Happy to be told what to do and follow
                                                                    orders
                                                                </li>
                                                                <li className="list-bottom-pad">Will delegate
                                                                    work to colleagues if required
                                                                </li>


                                                            </ul>
                                                            <p>Give them a supportive role where they can add
                                                                value and contribute without having to take
                                                                control. Make their responsibilities clear and
                                                                offer support.</p>

                                                        </td>

                                                    </tr>


                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="mobile ipad-portrait-hide">
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport tablesrink para-bottompad">


                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve" width="50%">Motivational
                                                            area
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Control</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">High (4-5)</td>
                                                        <td valign="top">
                                                            <ul className="greenbullet-list">
                                                                <li>Likes to take control of team activities
                                                                </li>
                                                                <li> Does things in own way, regardless of
                                                                    feedback
                                                                </li>
                                                                <li>Does not like uncertain situations</li>
                                                                <li className="list-bottom-pad"> May find it
                                                                    difficult to delegate to others
                                                                </li>

                                                            </ul>
                                                            <p>Provide them with however much responsibility or
                                                                ownership you’re happy to! Clarify the
                                                                boundaries between their role and those of
                                                                others.</p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius">Low
                                                            (1-2)
                                                        </td>
                                                        <td valign="top" id="m-border-light">
                                                            <ul className="greenbullet-list">
                                                                <li> Will allow others to lead</li>
                                                                <li>Best employed in a supporting role where
                                                                    others take charge
                                                                </li>
                                                                <li> Happy to be told what to do and follow
                                                                    orders
                                                                </li>
                                                                <li className="list-bottom-pad">Will delegate
                                                                    work to colleagues if required
                                                                </li>


                                                            </ul>
                                                            <p>Give them a supportive role where they can add
                                                                value and contribute without having to take
                                                                control. Make their responsibilities clear and
                                                                offer support.</p>

                                                        </td>
                                                    </tr>

                                                    </tbody>
                                                </table>
                                            </div>


                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">Further Information</span>
                                            </div>
                                            <div className="paraspace"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept further_bullet_spacing">
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToRaiseEnergyLevels')}>How
                                                        to raise energy levels</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToInfluenceOthers')}>How
                                                        to influence others</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToDevelopOthers')}>How
                                                        to develop others</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToEngageOthersToDeliver')}>How
                                                        to engage others to deliver</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToUseOptimismToAchieve')}>How
                                                        to use optimism to achieve</div></li>

                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>REFERENCES</div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Weiner, I. et al.
                                                    (2003).<span className="subtiltereg"> Handbook of Psychology.</span> John
                                                    Wiley and Sons.</p></li>
                                                <li><p className="further_info_content">(Maslow’s Hierarchy of
                                                    Needs; McGregor’s Theory X/Theory Y; Attribution Theory;
                                                    Valency Theory; Herzberg’s Motivation-Hygiene Theory).</p>
                                                </li>
                                                <li><p className="further_info_content">Lawler, E. (1994).<span
                                                    className="subtiltereg"> Motivation in work organizations.</span> San
                                                    Francisco: Jossey-Bass, Inc.</p></li>
                                            </ol>

                                            <div className="left-btn"><div
                                                onClick={this.props.handleChangePage('Page10')}
                                                className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                            <div className="right-btn"><div
                                                onClick={this._savePageStatus('People')}
                                                className="button-next-previous-done">Done</div></div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}